import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const RelocationModal = ({
  show,
  onHide,
  value = "",
  onSave,
  shouldUpdateProfile = false,
  isApplyPage = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedOption, setSelectedOption] = useState("");
  const [error, setError] = useState("");

  const relocateOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
    { value: "open", label: "Open" },
  ];
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  // Load existing value
  // useEffect(() => {
  //   if (!show) return;

  //   const current =
  //     store?.profileItem?.data?.nurseProfile?.willing_to_relocate;

  //   if (current) {
  //     setSelectedOption(current);
  //   }
  // }, [show, store?.profileItem]);
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      // ✅ Apply page
      setSelectedOption(value || "");
    } else {
      // ✅ Profile page
      const current =
        store?.profileItem?.data?.nurseProfile?.willing_to_relocate;

      if (current) {
        setSelectedOption(current);
      }
    }

    // ❗ ONLY depend on show
  }, [show]);

  const handleSelect = (value) => {
    setSelectedOption(value);
    setError("");
  };

  const handleSave = () => {
    if (!selectedOption) {
      setError("Please select an option");
      return;
    }

    if (isApplyPage) {
      // ✅ Always update local form
      onSave(selectedOption);

      // 🔥 ONLY call API if value was empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("willing_to_relocate", selectedOption);

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("willing_to_relocate", selectedOption);

      dispatch(updateProfile(formData));
    }
  };
  // const handleSave = () => {
  //   if (!selectedOption) {
  //     setError("Please select an option");
  //     return;
  //   }

  //   if (isApplyPage) {
  //     // ✅ LOCAL FLOW
  //     onSave(selectedOption);
  //     onHide();
  //   } else {
  //     // ✅ API FLOW
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         "",
  //     );

  //     formData.append("willing_to_relocate", selectedOption);

  //     dispatch(updateProfile(formData));
  //   }
  // };
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      dispatch(getViewProfile()); // reload profile data
      onHide();
    }
  }, [store?.actionFlag, dispatch]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Are you willing to relocate for work?</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {relocateOptions.map((option) => (
              <div
                key={option.value}
                className={`radio-option  col-lg-6 ${
                  selectedOption === option.value ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                <div className="contentwrap">
                  <input
                    type="radio"
                    checked={selectedOption === option.value}
                    readOnly
                  />

                  <label className="radio-label">{option.label}</label>
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || !selectedOption}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RelocationModal;
